import { REBATE_AGE_BRACKET } from '@ahmdigital/constants';
import { toInteger } from 'lodash/fp';

const getAgrAgeBracketFromAge = (age: number) => {
  const numberAge = toInteger(age);
  if (numberAge < 65) {
    return REBATE_AGE_BRACKET.BRACKET_0;
  }
  if (numberAge >= 70) {
    return REBATE_AGE_BRACKET.BRACKET_2;
  }
  return REBATE_AGE_BRACKET.BRACKET_1;
};

export default getAgrAgeBracketFromAge;
